import { useSelector } from 'react-redux'
import { selectIsVbUploading, selectPendingVbImage } from '../vb/reducer'
import Spinner from '../components/Spinner'
import './VirtualBackgroundStatus.css'
import { useVBNotifications } from './effects'
import { proxyPexelsImageUrl } from '../util/pexels'

export default function VirtualBackgroundStatus() {
  const isUploading = useSelector(selectIsVbUploading)
  const vbPendingImage = useSelector(selectPendingVbImage)

  useVBNotifications()

  if (!isUploading) return null

  return (
    <div className="VirtualBackgroundStatus">
      <div className="VirtualBackgroundStatus__thumbnail">
        {vbPendingImage && vbPendingImage.src && (
          <img
            alt={vbPendingImage.alt}
            src={proxyPexelsImageUrl(vbPendingImage.src.landscape)}
          />
        )}
      </div>
      <div>
        <div className="VirtualBackgroundStatus__header">
          <div className="VirtualBackgroundStatus__status">
            <Spinner /> Preparing selected background...
          </div>
        </div>
      </div>
    </div>
  )
}
